// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.area-superior {
  height: calc(100vh - 151px);
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (max-width: 600px) {
  .area-superior {
    height: calc(100vh - 136px);
  }
}
.imgMedInicio {
  max-height: 97%;
  max-width: 100%;
}

.mediciones-medidor {
  align-items: center;
  background-color: black;
  position: absolute;
  color: white;
  display: inline-grid;
  margin-left: -8px;
}

.p-medidor {
  font-family: "Calculator", sans-serif;
  color: greenyellow;
}

.nombre-medidor {
  width: 100%;
  text-align: center;
}

.mediciones-medidor p {
  margin-bottom: 0.1%;
}

.mediciones-medidor .row {
  padding-left: 0px;
}

.flex-right {
  padding-left: 0px;
  padding-right: 0px;
}

.flex-right p {
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/pages/K-sper%20station/Landing%20Client/landingClient.scss","webpack://./src/pages/K-sper station/Landing Client/landingClient.scss"],"names":[],"mappings":"AACA;EACI,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACAJ;;ADGA,oEAAA;AACA;EAEI;IACI,2BAAA;ECDN;AACF;ADKA;EACI,eAAA;EACA,eAAA;ACHJ;;ADMA;EACI,mBAAA;EAEA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;ACJJ;;ADSA;EACI,qCAAA;EACA,kBAAA;ACNJ;;ADSA;EACI,WAAA;EACA,kBAAA;ACNJ;;ADSA;EACI,mBAAA;ACNJ;;ADSA;EACI,iBAAA;ACNJ;;ADSA;EACI,iBAAA;EACA,kBAAA;ACNJ;;ADSA;EACI,iBAAA;ACNJ","sourcesContent":["\n.area-superior {\n    height: calc(100vh - 151px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n/* Small devices (portrait tablets and large phones, 600px and up) */\n@media only screen and (max-width: 600px) \n{\n    .area-superior {\n        height: calc(100vh - 136px);\n    }\n\n}\n\n.imgMedInicio{\n    max-height: 97%;\n    max-width: 100%;\n}\n\n.mediciones-medidor {\n    align-items: center;\n    // align-content: center;\n    background-color: black;\n    position: absolute;\n    color: white;\n    display: inline-grid;\n    margin-left: -8px;\n}\n\n\n\n.p-medidor {\n    font-family: 'Calculator', sans-serif;\n    color: greenyellow;\n}\n\n.nombre-medidor{\n    width: 100%;\n    text-align: center;\n}\n\n.mediciones-medidor p {\n    margin-bottom: 0.1%;\n}\n\n.mediciones-medidor .row {\n    padding-left: 0px;\n}\n\n.flex-right{\n    padding-left: 0px;\n    padding-right: 0px;\n}\n\n.flex-right p{\n    text-align: right;\n}\n",".area-superior {\n  height: calc(100vh - 151px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Small devices (portrait tablets and large phones, 600px and up) */\n@media only screen and (max-width: 600px) {\n  .area-superior {\n    height: calc(100vh - 136px);\n  }\n}\n.imgMedInicio {\n  max-height: 97%;\n  max-width: 100%;\n}\n\n.mediciones-medidor {\n  align-items: center;\n  background-color: black;\n  position: absolute;\n  color: white;\n  display: inline-grid;\n  margin-left: -8px;\n}\n\n.p-medidor {\n  font-family: \"Calculator\", sans-serif;\n  color: greenyellow;\n}\n\n.nombre-medidor {\n  width: 100%;\n  text-align: center;\n}\n\n.mediciones-medidor p {\n  margin-bottom: 0.1%;\n}\n\n.mediciones-medidor .row {\n  padding-left: 0px;\n}\n\n.flex-right {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\n.flex-right p {\n  text-align: right;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
